/// <reference path="../../polaris-web-components.d.ts" />
import React, { Component } from 'react';
import { useCallback, useEffect, useState, useMemo } from "react";
import { downloadCustomerBulkResult, customerBulkCancel, CustomerBulkPolling, DeleteCustomerLogs, getCustomerImportHistory, getShopUrl, customerExportStatus, checkPrevExportExist, getExportConfig, getTrialStatus } from '../Services/CommonServices';
import { environment } from '../Services/environment';
import { validConversionPrice } from '../Validation/regex';
import ImportHistory from '../common/ImportHistory';
import ImportProcessing from '../common/ImportProcessing';
import { ValidationErrorModal } from '../common/ValidationErrorModal';
import { errorMetaModal, errorModal,combinedErrorModal  } from '../common/ErrorModal';
import { ToastMarkup } from '../common/ToastMarkup';
import ExportStatusCard from '../common/ExportStatusCard';
import TrialExpiredBanner from '../common/TrialExpiredBanner';
import { useNavigate } from 'react-router-dom';
import WatermarkImage from '../../assets/3129492.jpg';
// import { useNavigationHistory } from '@shopify/app-bridge-react';
const endpoint = environment.serverUrl;

export default function Customers({ blockUpload,eventSource }) {
    const navigate = useNavigate();
    // const {push} = useNavigationHistory();
    var queryString = window.location.search;
    var storeUrl = getShopUrl();
    const [file, setFile] = useState();
    const [logsLoading, setLogsLoading] = useState(false);
    const [rejectedFiles, setRejectedFiles] = useState();
    const hasError = rejectedFiles != null;
    const validFileTypes = ['.csv','.CSV','text/csv','.xlsx','.XLSX'];
    const handleDropZoneDrop = useCallback(
        (_dropFiles, acceptedFiles, _rejectedFiles) => {
            setUploadErrors(false);
            setIsUploadError(false);
            setBulkErrors([]);
            setFile(acceptedFiles[0]);
            setRejectedFiles(_rejectedFiles[0]);
        },
        [],
    );
    const [rootObjectCount, setRootObjectCount] = useState(0);
    const [exportConfig, setExportConfig] = useState(null);
    const [exportResult, setExportResult] = useState({});
    let isExportConfig = false;
    const [mutationType, setMutationType] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [uploadStatus, setUploadStatus] = useState(false);
    const [exportStatus, setExportStatus] = useState("");
    const [uploadErrors, setUploadErrors] = useState([]);
    const [isUploadError, setIsUploadError] = useState(false);
    const [exportBtnLoading, setExportBtnLoading] = useState(false);
    const [downloadSpinner, setDownloadSpinner] = useState(false);
    const [conversionPrice, setConversionPrice] = useState();
    const [configLoading, setConfigLoading] = useState(false);
    
    // Trial authorization state
    const [trialInfo, setTrialInfo] = useState(null);
    const [showTrialBanner, setShowTrialBanner] = useState(false);
    const [ChargeUrl, setChargeUrl] = useState("");
    
    const [bulkStatus, setBulkStatus] = useState("");
    const [pollingResult, setPollingResult] = useState(undefined);
    const [bulkErrors, setBulkErrors] = useState([]);
    const [logs, setLogs] = useState([]);
    const [nxtButton, setNxtButton] = useState(true);
    const [prvButton, setPrvButton] = useState(true);
    const [loadingMap, setLoadingMap] = useState({});

    const pageSize = 10;
    let [pageNo, setPageNo] = useState(1);
    let [pageCount, setPageCount] = useState(0);
    const [bulkMetaErrorActive, setBulkMetaErrorActive] = useState(false);
    const [bulkMetaErrors, setBulkMetaErrors] = useState([]);
    const handleMetaBulkErrorChangeModal = useCallback(() => setBulkMetaErrorActive(!bulkMetaErrorActive), [bulkMetaErrorActive]);
    const handleChangeConversionPrice = useCallback((newValue) => { if (ValidatePrice(newValue)) { setConversionPrice(newValue) } }, []);
    
    // Memoized UI Components
    const fileUpload = useMemo(() => 
        !file && <s-text>Click here to upload a file</s-text>
    , [file]);
    
    const uploadedFile = useMemo(() => 
        file && (
            <s-stack direction="inline" gap="small" align="center">
                <s-thumbnail
                    size="small"
                    alt={file.name}
                    source={
                        validFileTypes.includes(file.type)
                            ? window.URL.createObjectURL(file)
                            : ''
                    }
                />
                <div>
                    <s-text>
                        {file.name}
                    </s-text>
                    <s-text as="p">
                        {file.size} bytes
                    </s-text>
                </div>
            </s-stack>
        )
    , [file, validFileTypes]);

    const [vendorArray, setVendorArray] = useState([]);
    const [selectedVendor, setSelectedVendor] = useState();
    const [popoverActive, setPopoverActive] = useState(false);
    const [errModalActive, setErrModalActive] = useState(false);
    const [bulkErrorActive, setBulkErrorActive] = useState(false);
    const handleErrorChangeModal = useCallback(() => setErrModalActive(!errModalActive), [errModalActive]);
    const handleBulkErrorChangeModal = useCallback(() => setBulkErrorActive(!bulkErrorActive), [bulkErrorActive]);
    const togglePopoverActive = useCallback(() => setPopoverActive((popoverActive) => !popoverActive), [],);
    const [uploadBtnLoading, setUploadBtnLoading] = useState(false);
    const [toast, setToast] = useState(false);
    const [toastContent, setToastContent] = useState('Saved');
    const [toastError, setToastError] = useState(false);
    const toggleToast = useCallback(() => setToast((toast) => !toast), []);
    const [processingMsg, setProcessingMsg] = useState('calculating items');
    const [catalogExtractMsg, setCatalogExtractMsg] = useState();
    const [customerDeleteStatus, setCustomerDeleteStatus] = useState();
    const [metaDeleteStatus, setMetaDeleteStatus] = useState();
    const [splitCustomers, setSplitCustomers] = useState();
    const [stagedUploadProgress, setStagedUploadProgress] = useState();
    const [customerBulkCancelStatus, setBulkCancelStatus] = useState("")
    const [emailMarketingUpdate,setEmailMarketingUpdate] = useState(undefined);

    useEffect(() => {
        getConfigExport();
        setFile(null);
        deleteOlderLogs();
        statusPolling();
        getLogs();
        checkExportStatus();
        loadTrialStatus(); // Load trial status on mount
    }, []);

    // Trial authorization helper functions
    const loadTrialStatus = async () => {
        try {
            const data = await getTrialStatus(storeUrl);
            setTrialInfo(data);
            
            // Show banner if trial expired and no active charge
            if (data.isTrialExpired && !data.hasActiveCharge) {
                setShowTrialBanner(true);
            }
        } catch (error) {
            console.error('Error loading trial status:', error);
        }
    };

    const checkTrialAccess = () => {
        if (!trialInfo) return true; // Loading state, allow temporarily
        
        if (!trialInfo.canAccessApp) {
            setShowTrialBanner(true);
            return false;
        }
        return true;
    };

    const handleTrialBannerDismiss = () => {
        setShowTrialBanner(false);
    };

    const handleUpgradeAction = () => {
        
        navigate('/plans' + queryString);
    };

    useEffect(() => {
         if (eventSource) {
        eventSource.onmessage = (event) => {
            const data = event.data;
            if (data.includes("customerProcessing")) {
                setUploadBtnLoading(false);
                setIsUploadError(false);
                setPollingResult(undefined);
                setUploadStatus(true);
                setBulkStatus("processing");
                setProcessingMsg("validating");
                setEmailMarketingUpdate(undefined);
                setFile(null);
            }
            if (data.includes("customerValidation")) {
                const { customerValidation } = JSON.parse(data);

                if (customerValidation === true) {
                    setUploadBtnLoading(false);
                    setIsUploadError(false);
                    setBulkStatus("processing");
                    setProcessingMsg("calculating items");
                    setEmailMarketingUpdate(undefined);
                    setFile(null);
                } else {
                    setFile(null);
                    setBulkStatus("failed");
                    setUploadStatus(false);
                    setPollingResult(undefined);
                    setUploadBtnLoading(false);
                    setIsUploadError(true);
                    setErrModalActive(true);
                    setUploadErrors(JSON.parse(data));
                    
                }
            } else if (data.includes("customeruploading")) {
                setPollingResult(undefined);
                setUploadStatus(true);
                setProcessingMsg("uploading");
                setStagedUploadProgress(JSON.parse(data));
                setUploadBtnLoading(false);
                
            } else if (data.includes("Customer delete")) {
                setPollingResult(undefined);
                setUploadStatus(true);
                setProcessingMsg("Customer delete");
                setCustomerDeleteStatus(JSON.parse(data));
            } else if (data.includes("CustomerMetafield delete")) {
                setPollingResult(undefined);
                setUploadStatus(true);
                setProcessingMsg("Metafield delete");
                setMetaDeleteStatus(JSON.parse(data));
            } else if (data.includes("bulkId")) {
                const jsonObject = JSON.parse(data);
                if (jsonObject) {
                    const { status } = jsonObject;

                    if (status.toLowerCase() === "completed") {
                        setPollingResult(jsonObject);
                        setBulkStatus(status);
                        setUploadStatus(false);
                        getLogs();
                    } else if (status.toLowerCase() === "canceled") {
                        setUploadStatus(false);
                        setBulkStatus(status);
                        getLogs();
                    } else {
                        setUploadStatus(true);
                        setBulkStatus(status);
                        setPollingResult(jsonObject);
                    }
                }
            } else if (data.includes("CustomerCatalog extract")) {
                const jsonObject = JSON.parse(data);
                setPollingResult(undefined);
                setUploadStatus(true);
                setBulkStatus("processing");
                setCatalogExtractMsg(jsonObject);
                setProcessingMsg("Catalog extract");
                setUploadBtnLoading(false);
            } else if (data.includes("Split customers")) {
                const jsonObject = JSON.parse(data);
                setPollingResult(undefined);
                setUploadStatus(true);
                setBulkStatus("processing");
                setProcessingMsg("Split customers");
                setUploadBtnLoading(false);
                setSplitCustomers(jsonObject);
            } else if (data.includes("bulkop")) {
                const jsonObject = JSON.parse(data);
                if (jsonObject.status = "canceled") { setBulkStatus(false); setPollingResult(undefined); setBulkCancelStatus(""); getLogs(); }
                else {
                    setBulkCancelStatus(jsonObject.status);
                }
            } else if (data === "pong") {
            } else if (data === "customerDownloadComplete") {
                setDownloadSpinner(false);
                getConfigExport();
            }
            else if (data.includes("customerfailed")) {
                setExportStatus("failed");
                setDownloadSpinner(false);
            }
            else if(data.includes("customer-email-consent"))
            {
                const jsonObject = JSON.parse(data);
                if (jsonObject) {
                    const { status } = jsonObject;
                setEmailMarketingUpdate(JSON.parse(data));
                setUploadStatus(true);
                if(status === "completed") { setUploadStatus(false); }
                }
            }
            else if (data.includes("Export")) {
                if (exportConfig === null && !isExportConfig) {
                    isExportConfig = true;

                }
                try {
                    const jsonObject = JSON.parse(data);
                    if (jsonObject) {
                        const { type, status, completedAt } = jsonObject;
                        if (type.includes("Product")) { setMutationType("product"); }
                        else if (type.includes("Customer")) { 
                            setMutationType("customer"); 
                            setExportResult(jsonObject); 
                        }
                        if (status.toLowerCase() === "completed" || status.toLowerCase() === "failed" || status.toLowerCase() === "expired") {
                            setDownloadSpinner(false);
                            setExportBtnLoading(false);
                            if (type.includes("Customer")) {
                                setExportResult(jsonObject);
                                setExportStatus(status.toLowerCase());
                                setExportCompletedAt(completedAt);
                                // Refresh export config to get the latest data
                                getConfigExport();
                            }

                            if (type === "CustomerExport") {
                                setDownloadSpinner(false);
                                setExportBtnLoading(false);
                                // window.location.href = endpoint + '/api/Customer/download-previous-export?storeUrl=' + storeUrl;
                            }
                        }
                        setExportStatus(status.toLowerCase());
                    }
                } catch (err) {
                    console.warn("Non-JSON message received:", data);
                }
            }

        }
    }

        return () => {
            if (eventSource) {
              eventSource.onmessage = null; // Remove the event handler
            }
          };
        }, [eventSource]);

    const activator = (
        <s-button onClick={togglePopoverActive} disclosure>
            Export
        </s-button>
    );



    const bulkResponseErrorModal = (
        <s-modal
            id="bulk-error-modal"
            size="base"
            heading="Failed customers"
            padding="none"
        >
            <s-table padding="none">
                <s-table-header-row>
                    <s-table-header>Sl No</s-table-header>
                    <s-table-header>Email</s-table-header>
                    <s-table-header>Error</s-table-header>
                </s-table-header-row>
                <s-table-body>
                    {bulkErrors?.map(({ handle, userErrors, email }, index) => (
                        <s-table-row key={index}>
                            <s-table-cell>
                                <s-text type="strong">{index + 1}</s-text>
                            </s-table-cell>
                            <s-table-cell>
                                <s-text>{email || handle}</s-text>
                            </s-table-cell>
                            <s-table-cell>
                                <s-text tone="critical">
                                    {userErrors?.[0]?.message || 'Unknown error'}
                                </s-text>
                            </s-table-cell>
                        </s-table-row>
                    ))}
                </s-table-body>
            </s-table>
            
            <s-button 
                slot="primary-action"
                commandFor="bulk-error-modal"
                command="--hide"
                onClick={handleBulkErrorChangeModal}
            >
                Close
            </s-button>
        </s-modal>
    );



    function next() {
        pageNo = pageNo + 1
        if (pageNo <= pageCount) {
            setPageNo(pageNo);
            getLogs();
            setPrvButton(true);
        }
        else { setNxtButton(false); setPrvButton(true); }
    }
    function prev() {
        pageNo = pageNo - 1
        if (pageNo >= 1) {
            setPageNo(pageNo);
            getLogs();
            setNxtButton(true)
        }
        else { setPrvButton(false); setNxtButton(true) }
    }

    function generateCustomerErrorModal(errors) {
        setBulkErrors(errors);
        setBulkErrorActive(true);
        
        // Open the modal using command after state update
        setTimeout(() => {
            const modal = document.getElementById('bulk-error-modal');
            if (modal) {
                modal.dispatchEvent(new CustomEvent('command', { detail: { action: 'show' } }));
            }
        }, 0);
    }

    function generateMetafieldErrorModal(errors) {
        setBulkMetaErrors(errors);
        setBulkMetaErrorActive(true)
        setTimeout(() => {
            const modal = document.getElementById('bulk-meta-error-modal');
            if (modal) {
                modal.dispatchEvent(new CustomEvent('command', { detail: { action: 'show' } }));
            }
        }, 0);
    }

    function generateCombinedErrorModal(customerErrors, metafieldErrors) {
        setBulkErrors(customerErrors || []);
        setBulkMetaErrors(metafieldErrors || []);
        setBulkErrorActive(true);
        
        setTimeout(() => {
            const modal = document.getElementById('combined-error-modal');
            console.log('Modal element found:', modal);
            if (modal) {
                modal.dispatchEvent(new CustomEvent('command', { detail: { action: 'show' } }));
            } else {
                console.error('Combined error modal not found in DOM');
            }
        }, 0);
    }

    // var exportStatusBanner = (
    //     <Banner
    //         title={exportStatus === "completed" ? "Export " + (mutationType !== '' && mutationType !== undefined ? " " + mutationType : "") + " completed" : "Export " + (mutationType !== '' && mutationType !== undefined ? " " + mutationType : "") + " " + exportStatus}
    //         action={{
    //             disabled:exportStatus === "failed" || exportStatus === "running" ? true : false,
    //             content: 'Download Exported File', loading: downloadSpinner,  onAction: () => {
    //                 setDownloadSpinner(true);
    //                 try {
    //                     window.location.href = endpoint + '/api/Customer/download-previous-export?storeUrl=' + storeUrl;
    //                   } catch (error) {
    //                     setExportStatus("failed")
    //                     setExportLoading(false)
    //                   } 
    //             },
    //         }}
    //         status={exportStatus === "completed" ? "success" : exportStatus === "failed" ? "critical" : "info"}
    //         onDismiss={() => setExportStatus("")}>
    //             {exportStatus === "running" ? <p>This may take a few moments.</p> : null}
    //     </Banner>
    // );
    const [exportCompletedAt, setExportCompletedAt] = useState('');
    const [exportModalActive, setExportModalActive] = useState(false);
    const exportModal = (
        <>
            <s-modal
                open={exportModalActive}
                onClose={() => {setExportModalActive(false)}}>
                <div slot="title">Export</div>
                
                <s-box padding="large">
                    <s-banner
                        tone={exportStatus === "completed" ? "success" : exportStatus === "failed" ? "critical" : "info"}
                        onDismiss={false}>
                        <s-text>
                            {exportStatus === "completed" ?
                                "Export " + (mutationType !== '' && mutationType !== undefined ? " " + mutationType : "") + " completed on " + new Date(exportCompletedAt).toLocaleDateString() + " at " + new Date(exportCompletedAt).toLocaleTimeString() + ". "
                                : exportStatus === "" ?  "No previous export Found. Please export again." :  "Export " + (mutationType !== '' && mutationType !== undefined ? " " + mutationType : "") + " " + exportStatus + (exportStatus !== "failed"  && exportStatus !== "canceled"? ". This may take a few moments." : ".")}
                            {exportStatus === "completed" && !downloadSpinner? <s-link url="" onClick={() => {
                                setDownloadSpinner(true);
                                window.location.href = endpoint + '/api/Customer/download-previous-export?storeUrl=' + storeUrl;
                            }}>Download</s-link> : downloadSpinner ? <s-spinner size="small" /> : null}
                        </s-text>
                    </s-banner>
                </s-box>
                
                <div slot="footer">
                    <s-button-group>
                        <s-button 
                            variant="primary"
                            onClick={exportAllCustomers}
                            disabled={exportStatus === 'running' || exportStatus === 'failed' || uploadStatus || blockUpload ? true : false}
                        >
                            Export
                        </s-button>
                        <s-button onClick={() => {setExportModalActive(false)}}>
                            Cancel
                        </s-button>
                    </s-button-group>
                </div>
            </s-modal>
        </>
    );


    return (
        <s-page heading='Customers'>
            <s-link slot="breadcrumb-actions" href={'/dashboard?' + queryString}>Dashboard</s-link>
            <s-button 
                slot="primary-action"
                onClick={() => { exportAllCustomers() }}
                disabled={exportStatus !== "running" && !uploadStatus && !blockUpload ? false : true}
            >
                {exportStatus !== "completed" && exportStatus !== "" ? (
                    <s-tooltip>
                        <span slot="trigger">
                            {exportBtnLoading ? <s-spinner size="small"></s-spinner> : <s-icon source="circle-down" />}
                            <s-text>Export</s-text>
                        </span>
                        <span slot="content">
                            {`${mutationType ? ` ${mutationType}` : ""} ${exportStatus}${exportStatus !== "failed" && exportStatus !== "canceled" ? ". This may take a few moments." : "."}`}
                        </span>
                    </s-tooltip>
                ) : (
                    <>
                        <s-icon source="circle-down" />
                        Export
                    </>
                )}
            </s-button>
            
            {/* Trial Expired Banner */}
            <TrialExpiredBanner
                show={showTrialBanner}
                remainingDays={trialInfo?.remainingTrialDays || 0}
                onDismiss={handleTrialBannerDismiss}
                onUpgrade={handleUpgradeAction}
            />

            {/* {exportStatus !== "" && !blockUpload && exportStatus !== "expired" ? exportStatusBanner : null } */}
            
            <s-stack gap="base">
                {/* Main Card - Two columns layout with grid */}
                <s-section padding="base">
                    <s-box padding="none">
                        <s-grid gridTemplateColumns="repeat(12, 1fr)" gap="large">
                            <s-grid-item gridColumn="span 6">
                                <s-stack gap="small">
                                    {/* DropZone Section */}
                                    <s-stack gap="small-100">
                                        <s-heading>Upload File</s-heading>
                                        <s-link onClick={() => openSampleFile()}>
                                            Download a sample file
                                        </s-link>
                                        
                                        <s-drop-zone
                                            multiple={false}
                                            accept=".csv,.xlsx"
                                            onInput={(event) => {
                                                const files = event.currentTarget.files;
                                                if (files && files.length > 0) {
                                                    handleDropZoneDrop([], Array.from(files), []);
                                                }
                                            }}
                                        >
                                            {uploadedFile}
                                            {fileUpload}
                                        </s-drop-zone>
                                        
                                        <s-text color="subdued">
                                            Accepts .csv/.xlsx format. Maximum size: 20 MB
                                        </s-text>
                                    </s-stack>

                                    {/* Action Buttons Section */}
                                    <s-stack gap="small-100">
                                        <s-stack direction="inline" gap="small">
                                            <s-button
                                                variant="primary"
                                                disabled={!file || uploadStatus || blockUpload || exportStatus === "running"}
                                                loading={uploadBtnLoading}
                                                onClick={() => FileUploadValidation()}
                                            >
                                                Upload
                                            </s-button>
                                            {/* <s-button 
                                                variant="secondary" 
                                                onClick={() => openSampleFile()}
                                            >
                                                Download sample
                                            </s-button> */}
                                        </s-stack>
                                        
                                        {hasError && (
                                            <s-text as="p" tone="critical">
                                                {`"${rejectedFiles?.name}" is not supported. File type must be .csv or .xlsx`}
                                            </s-text>
                                        )}
                                    </s-stack>
                                </s-stack>
                            </s-grid-item>
                            
                            <s-grid-item gridColumn="span 6">
                                {/* Note Section with Image Watermark */}
                                <div style={{ position: 'relative'}}>
                                    {/* Watermark Image Background */}
                                    <div 
                                        style={{
                                            position: 'absolute',
                                            bottom: '-65px',
                                            right: '10px',
                                            width: '300px',
                                            height: '300px',
                                            backgroundImage: `url(${WatermarkImage})`,
                                            backgroundSize: 'contain',
                                            backgroundRepeat: 'no-repeat',
                                            backgroundPosition: 'bottom right',
                                            opacity: '0.15',
                                            pointerEvents: 'none',
                                            zIndex: 0
                                        }}
                                    />
                                    
                                    {/* Note Content - On top of watermark */}
                                    <div style={{ position: 'relative', zIndex: 1 }}>
                                        <s-stack gap="small-100">
                                            <s-heading>Note</s-heading>
                                            <s-unordered-list>
                                                <s-list-item>
                                                    Metafields are separate column headers with the format: <s-text type="strong">customer/namespace/metafield-name/type</s-text>
                                                </s-list-item>
                                                <s-list-item>
                                                    To delete a metafield, end the header with <s-text type="strong">'/delete'</s-text>
                                                </s-list-item>
                                                <s-list-item>
                                                    Image urls in metafields can be comma(,) separated in the first row of the customer.
                                                </s-list-item>
                                                <s-list-item>
                                                    Image urls from Google Drive and Dropbox share links are automatically updated by us to be accepted in Shopify
                                                </s-list-item>
                                                <s-list-item>
                                                    The app supports bulk operations for customers and their metafields efficiently
                                                </s-list-item>
                                            </s-unordered-list>
                                        </s-stack>
                                    </div>
                                </div>
                            </s-grid-item>
                        </s-grid>
                    </s-box>
                </s-section>
            </s-stack>
            
            <ImportProcessing
                bulkStatus={bulkStatus}
                uploadStatus={uploadStatus}
                pollingResult={pollingResult}
                setErrModalActive={setErrModalActive}
                processingMsg={processingMsg}
                catalogExtractMsg={catalogExtractMsg}
                stagedUploadProgress={stagedUploadProgress}
                splitItems={splitCustomers}
                productDeleteStatus={customerDeleteStatus}
                metaDeleteStatus={metaDeleteStatus}
                productBulkCancelStatus={customerBulkCancelStatus}
                cancelBulk={cancelBulk}
                generateProductErrorModal={generateCustomerErrorModal}
                generateMetafieldErrorModal={generateMetafieldErrorModal}
                generateCombinedErrorModal={generateCombinedErrorModal}
                emailMarketingUpdate={emailMarketingUpdate}
                isCustomerImport={true}
            />
            {(exportResult !== undefined && exportConfig !== null) || exportStatus === "running" ?
                
                    <ExportStatusCard exportResult={exportResult} progress={0} exportConfig={exportConfig} currentRoute="customer" />
                
                : null}
            
            <s-box paddingBlockStart= "base">
            <s-section padding="none">
                <ImportHistory
                    logs={logs}
                    generateProductErrorModal={generateCustomerErrorModal}
                    generateMetafieldErrorModal={generateMetafieldErrorModal}
                    generateCombinedErrorModal={generateCombinedErrorModal}
                    downloadResult={downloadResult}
                    loadingMap={loadingMap}
                    logsLoading={logsLoading}
                    isCustomerImport={true}
                />
                
                {logs.length !== 0 && (
                    <s-stack direction="inline" align="center">
                        <s-pagination
                            has-previous={prvButton}
                            onPrevious={() => prev()}
                            has-next={nxtButton}
                            onNext={() => next()}
                        />
                    </s-stack>
                )}
            </s-section>
            </s-box>
            
            {/* Always render modals so they exist in DOM for getElementById */}
            {combinedErrorModal({ 
                bulkErrors, 
                bulkMetaErrors 
            })}
            {/* {errorModal({ bulkErrorActive, handleBulkErrorChangeModal, bulkErrors })}
            {errorMetaModal({ bulkMetaErrorActive, handleMetaBulkErrorChangeModal, bulkMetaErrors })} */}
            {exportModal}
            {/* {bulkErrors.length > 0 ? bulkResponseErrorModal : null} */}
            
            {/* {bulkErrors.length > 0 ? bulkResponseErrorModal : null} */}
            {isUploadError ? <ValidationErrorModal
                errModalActive={errModalActive}
                handleErrorChangeModal={handleErrorChangeModal}
                uploadErrors={uploadErrors}
            /> : null}
            <ToastMarkup toast={toast} toggleToast={toggleToast} content={toastContent} error={toastError} />

            {/* {resultDownloadErrorToast} */}
        </s-page>
        // </Frame>
    );

    async function downloadResult(op, bulkId) {
        setLoadingMap((prevLoadingMap) => ({ ...prevLoadingMap, [bulkId + "_" + op]: true }));
        try {
            await downloadCustomerBulkResult(storeUrl, bulkId, op);
        } catch (error) {
            setLoadingMap((prevLoadingMap) => ({ ...prevLoadingMap, [bulkId + "_" + op]: false }));
        } finally {
            setLoadingMap((prevLoadingMap) => ({ ...prevLoadingMap, [bulkId + "_" + op]: false }));
        }
    }

    function openSampleFile() {
        window.open(environment.customerSampleFile, '_blank');
      }

    async function cancelBulk(bulkId) {
        customerBulkCancel(storeUrl, bulkId).then(function (result) {
            setBulkCancelStatus("canceling");
            getLogs();
        });
    }



    function FileUploadValidation() {
        // Check trial access first
        if (!checkTrialAccess()) {
            return; // Banner will show automatically
        }

        if (file !== null) {
            setUploadStatus(true);
            setPollingResult(undefined);
            setBulkStatus("validating")
            setProcessingMsg("validating");
            setIsUploadError(false);
            setUploadErrors(false);
            setBulkErrors([]);
            setUploadBtnLoading(true);
            const formData = new FormData();
            formData.append("file", file);
            const requestOptions = {
                method: 'POST',
                body: formData
            };
            fetch(endpoint + '/api/Customer/file-validation?storeUrl=' + storeUrl, requestOptions)
            setFile(null);
        }
    }


    function deleteOlderLogs() {
        DeleteCustomerLogs(storeUrl).then(function (result) {
        });
    }


    function exportAllCustomers() {
        if (!checkTrialAccess()) {
            return; // Banner will show automatically
        }
        
        // Set initial export state
        setExportStatus('running');
        setExportBtnLoading(true);
        
        // Initialize export result with running status
        setExportResult({
            type: 'CustomerExport',
            status: 'RUNNING',
            createdAt: new Date().toISOString(),
            completedAt: null,
            rootObjectCount: 0
        });
        
        // Initialize export config with running status if it's null
        if (exportConfig === null) {
            setExportConfig({
                status: 'running',
                createdAt: new Date().toISOString(),
                fileUrl: null
            });
        }
        
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        };
        fetch(endpoint + '/api/Customer/export-customer?storeUrl=' + storeUrl, requestOptions)
            .then(async response => {
                if (response.status === 200 && response !== null) {
                    setExportBtnLoading(false);
                }
                else if (response.status === 400) {
                    setExportBtnLoading(false);
                    const errorData = await response.json();
                    setToastContent(errorData.message || 'Unable to download CSV');
                    setToastError(true);
                    setToast(true);
                    return;
                }
            })
            .catch(error => {
                setExportBtnLoading(false);
                setToastContent('Unable to download CSV. Please try again.');
                setToastError(true);
                setToast(true);
            })
    }


    function statusPolling() {
        CustomerBulkPolling(storeUrl).then(function (result) {
            if (result !== null) {
                var status = result.status;
                if (status.toLowerCase() === "completed") {
                    setPollingResult(result);
                    setBulkStatus(status);
                    setUploadStatus(false);
                    getLogs();
                }
                else if (status.toLowerCase() === "canceled") {
                    setUploadStatus(false);
                    setBulkStatus(status);
                    getLogs();
                }
                else {
                    setUploadStatus(true);
                    setBulkStatus(status);
                    setPollingResult(result);
                }
            }
            else {
            }
        })
    }
    function checkExportStatus() {
        customerExportStatus(storeUrl).then(function (result) {
            setDownloadSpinner(true);
            if (result !== null) {
                var status = result?.status?.toLowerCase();
                var type = result.type
                if (status === "completed" && type === "customer") {
                    setMutationType(type);
                    setExportStatus(status)
                    setExportCompletedAt(result.completedAt)
                    setExportResult(result);
                    setDownloadSpinner(false);
                }
                else if (type === "customer" && status === "running" ) {
                    setMutationType(type);
                    setExportStatus(status)
                    setExportResult(result);
                    setDownloadSpinner(true);
                }
                else if (type === "customer" && status === "processing" ) {
                    setMutationType(type);
                    setExportStatus(status)
                    setExportResult(result);
                    setDownloadSpinner(true);
                }
                else if (status === "failed" && type === "customer") {
                    setDownloadSpinner(false);
                    setMutationType(type);
                    setExportResult(result);
                    setExportStatus("failed")
                    
                }

                else if (status === "failed" && type === "product") {
                    setExportStatus("completed")
                    setDownloadSpinner(false);
                }

                else if (type !== "customer" && status === "running" )
                {
                    setMutationType(type);
                    setExportStatus(status)
                    setExportResult(result);
                }

                else {
                    // setMutationType(type);
                    // setExportStatus("")
                    // checkPrevExport();
                    setExportResult(result);
                    setDownloadSpinner(false);
                }
            }
            else
            {
                setDownloadSpinner(false);
            }
        })
    }
    function ValidatePrice(price) {
        if (validConversionPrice.test(price)) {
            return true;
        }
        else {
            return false;
        }

    }

    function getLogs() {
        setLogsLoading(true);
        getCustomerImportHistory(storeUrl, pageNo, pageSize).then(function (result) {
            if (result !== null) {
                setLogs(result.results);
                setPageCount((result.totalCount / pageSize) + 1);
                setLogsLoading(false);
            }
            else {
                setLogsLoading(false);
            }
        });
    }

    function checkPrevExport() {
        checkPrevExportExist(storeUrl, "Customer").then(function (result) {
            if (result !== null) {
                if(result.exists)
                {
                    setExportCompletedAt(result.lastModified);
                    setExportStatus("completed");
                }
                else
                {
                    setExportStatus("");
                    setMutationType("customer");
                }
            }
        });
    }

    function getConfigExport() {
        getExportConfig(storeUrl,"customer").then(function (result) {
            if (result !== null) {
                setExportConfig(result);
            }
        });
    }
}

